// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "servicechannel.proto" (syntax proto3)
// tslint:disable
import { ServiceChannelService } from "./servicechannel";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service ServiceChannelService
 */
export class ServiceChannelServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = ServiceChannelService.typeName;
        this.methods = ServiceChannelService.methods;
        this.options = ServiceChannelService.options;
    }
    /**
     * OAuth operations
     *
     * @generated from protobuf rpc: GetAuthURL
     */
    getAuthURL(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ExchangeCode
     */
    exchangeCode(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RefreshToken
     */
    refreshToken(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * PM checklist
     *
     * @generated from protobuf rpc: GetChecklist
     */
    getChecklist(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SaveChecklistAnswers
     */
    saveChecklistAnswers(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Job view (86baumq2k, 86baumpjf)
     *
     * @generated from protobuf rpc: GetJobLink
     */
    getJobLink(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBadge
     */
    getBadge(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SubmitProposal
     */
    submitProposal(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RetrySyncEvent
     */
    retrySyncEvent(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * On Call check-in feedback (86bc18e7q). Sends the row's check-in now and
     * reports the outcome; idempotent for an already-recorded visit.
     *
     * @generated from protobuf rpc: SendVisitCheckIn
     */
    sendVisitCheckIn(input, options) {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Job close-out (86bc12cgh). The check-out twin of SendVisitCheckIn: sends
     * the Completed / Incomplete row's check-out now and reports the outcome;
     * idempotent for a check-out already delivered, and the Retry for one that
     * was refused. Never moves the job's Kalos status: a held Completed moves
     * to Admin Review only when ServiceChannel accepts the push. Answers
     * FailedPrecondition when ServiceChannel already shows the work order
     * completed or invoiced, since a resend would be refused (921).
     *
     * @generated from protobuf rpc: SendVisitCheckOut
     */
    sendVisitCheckOut(input, options) {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Phone check-in fallback (86bc18e7q). GetPhoneCheckIn is what the dialog
     * shows; ReportPhoneCheckIn is called when the technician taps Call now, so
     * dispatch hears that this arrival is being recorded by phone.
     *
     * @generated from protobuf rpc: GetPhoneCheckIn
     */
    getPhoneCheckIn(input, options) {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReportPhoneCheckIn
     */
    reportPhoneCheckIn(input, options) {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Job close-out (86bc12cgh). The check-out twin of ReportPhoneCheckIn: the
     * same dialog (GetPhoneCheckIn answers the line, PIN and work order for both
     * directions) with "press 2 to clock out". Called when the technician taps
     * Call now on a refused check-out, so the job's activity log and the
     * dispatch card say the departure is being clocked out by phone. Nothing is
     * sent to ServiceChannel; the call is the check-out there.
     *
     * @generated from protobuf rpc: ReportPhoneCheckOut
     */
    reportPhoneCheckOut(input, options) {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Mapping administration. All gated on ServiceChannelAdmin.
     *
     * @generated from protobuf rpc: ListSCSubscribers
     */
    listSCSubscribers(input, options) {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListSCUnmappedTrades
     */
    listSCUnmappedTrades(input, options) {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetSCTradeMapping
     */
    batchGetSCTradeMapping(input, options) {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateSCTradeMapping
     */
    createSCTradeMapping(input, options) {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSCTradeMapping
     */
    updateSCTradeMapping(input, options) {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteSCTradeMapping
     */
    deleteSCTradeMapping(input, options) {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetSCPriorityMapping
     */
    batchGetSCPriorityMapping(input, options) {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateSCPriorityMapping
     */
    createSCPriorityMapping(input, options) {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSCPriorityMapping
     */
    updateSCPriorityMapping(input, options) {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteSCPriorityMapping
     */
    deleteSCPriorityMapping(input, options) {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetSCStatusMapping
     */
    batchGetSCStatusMapping(input, options) {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateSCStatusMapping
     */
    createSCStatusMapping(input, options) {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSCStatusMapping
     */
    updateSCStatusMapping(input, options) {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteSCStatusMapping
     */
    deleteSCStatusMapping(input, options) {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Technician -> ServiceChannel user (the phone check-in PIN). Upsert rather
     * than create/update: the row is keyed by the Kalos user.
     *
     * @generated from protobuf rpc: BatchGetSCTechnicianMapping
     */
    batchGetSCTechnicianMapping(input, options) {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpsertSCTechnicianMapping
     */
    upsertSCTechnicianMapping(input, options) {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteSCTechnicianMapping
     */
    deleteSCTechnicianMapping(input, options) {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * EPA 608 cards (86bc12cgh). A refrigerant Yes at close-out must be signed
     * by a technician with a card on file. "On file" is ServiceChannel's
     * provider record when the Contractor Tools user is configured and the
     * technician is mapped, and Kalos's own mirror otherwise.
     *
     * @generated from protobuf rpc: GetSCTechnicianCertification
     */
    getSCTechnicianCertification(input, options) {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListSCCertifiedTechnicians
     */
    listSCCertifiedTechnicians(input, options) {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateSCTechnicianCertification
     */
    createSCTechnicianCertification(input, options) {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Reads the card's number, level and dates off a photo so the form can be
     * prefilled; every field stays editable because the read can be wrong.
     *
     * @generated from protobuf rpc: ParseSCCertificationCard
     */
    parseSCCertificationCard(input, options) {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Customer ServiceChannel settings (86bc1a4eg). Both writes are gated on
     * ServiceChannelAdmin and answer with the customer's settings after the
     * change.
     *
     * @generated from protobuf rpc: GetSCCustomerSettings
     */
    getSCCustomerSettings(input, options) {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetSCCustomerEnabled
     */
    setSCCustomerEnabled(input, options) {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetSCStoreAutoAccept
     */
    setSCStoreAutoAccept(input, options) {
        const method = this.methods[37], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Inbound work orders (86bc12jtg). List returns pending work orders ordered
     * by time remaining against SLA; Get returns one in any state. Accept and
     * Decline answer with the work order after the decision, and refuse one
     * that has already been decided.
     *
     * @generated from protobuf rpc: ListSCInboundWorkOrders
     */
    listSCInboundWorkOrders(input, options) {
        const method = this.methods[38], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSCInboundWorkOrder
     */
    getSCInboundWorkOrder(input, options) {
        const method = this.methods[39], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AcceptSCInboundWorkOrder
     */
    acceptSCInboundWorkOrder(input, options) {
        const method = this.methods[40], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeclineSCInboundWorkOrder
     */
    declineSCInboundWorkOrder(input, options) {
        const method = this.methods[41], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
